/* global axios */

class PipelineInboxesAPI {
  get(accountId, pipelineId) {
    return axios.get(
      `/api/v1/accounts/${accountId}/pipelines/${pipelineId}/inboxes`
    );
  }

  update(accountId, pipelineId, inboxIds) {
    return axios.put(
      `/api/v1/accounts/${accountId}/pipelines/${pipelineId}/inboxes`,
      { inbox_ids: inboxIds }
    );
  }
}

export default new PipelineInboxesAPI();
